import store from '~/store'

export default async (to, from, next) => {

  if (to.query.t) {
    try {
      await store.dispatch('courses/fetchTerms')
      await store.dispatch('courses/updateTerm', { term: to.query.t })
    } catch (e) { }
  }

  if (to.query.d) {
    try {
      await store.dispatch('courses/updateDepartment', { department: to.query.d })
    } catch (e) { }
  }

  if (to.query.sub) {
    try {
      await store.dispatch('courses/updateSubject', { subject: to.query.sub })
    } catch (e) { }
  }

  if (to.query.s) {
    try {
      await store.dispatch('courses/updateStatus', { status: to.query.s })
    } catch (e) { }
  }

  next()
}



// WEBPACK FOOTER //
// /resources/js/middleware/check-params.js